import { CombinedError } from '@pypestream/api-services/urql';
import { throwErrorWithId } from '@pypestream/utils';

import { haveErrors } from './have-errors';

export interface DataErrorInternalObject {
  response: {
    body: {
      errors: string;
    };
  };
}

interface Response<T> {
  data?: T;
  error?: CombinedError;
}

export const checkForErrors = <T>(response: Response<T>): void => {
  const { data, error } = response;

  if (haveErrors(data)) {
    const dataErrorMessage =
      data.errors?.[0]?.message || 'Unknown GraphQL data error';

    throwErrorWithId(dataErrorMessage, { data });
  }

  if (error) {
    const errorMessage =
      (
        error.graphQLErrors?.[0]?.extensions
          ?.internal as DataErrorInternalObject
      )?.response?.body?.errors || error.message;

    throwErrorWithId(
      typeof errorMessage === 'string'
        ? errorMessage
        : JSON.stringify(errorMessage),
      { error }
    );
  }
};
